module.exports = __webpack_public_path__ + "static/img/indexBg.9866a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexBg.jpg
// module id = 0esl
// module chunks = 0